import { toJS } from 'mobx'

import {
  DataForFilter,
  FilterTicketForm,
} from 'entities/ticket/models/find-ticket/models.ts'

import { TypeRefundTicketAvia } from 'shared/constants'
import { simpleIsEqual } from 'shared/lib/simpleIsEqual.ts'

export const getIsActiveReset = (
  state: FilterTicketForm,
  filterDataFromRequest: DataForFilter | null,
): boolean => {
  return (
    Boolean(state.baggage) ||
    Boolean(state.transfers) ||
    Boolean(state.time) ||
    Boolean(state.durationOfTransfers) ||
    Boolean(state.isWithChangeAirport) ||
    Boolean(state.isWithRepeatRegistration) ||
    Boolean(state.isWithNightTransition) ||
    (state.refundTicket || TypeRefundTicketAvia.All.key) !==
      TypeRefundTicketAvia.All.key ||
    !simpleIsEqual(state.rangePrice, toJS(filterDataFromRequest?.priceRange))
  )
}
